import { Component, OnInit } from '@angular/core';
import { SessionService } from 'app/core/services/session.service';
import { Router, ActivatedRoute } from '@angular/router';

import { MiddlemanService } from 'app/core/services/middleman.service';

declare var $: any;

@Component({
	selector: 'itpx-create-credit-application',
	templateUrl: './create-credit-application.component.html',
	styleUrls: ['./create-credit-application.component.css']
})
export class CreateCreditApplicationComponent implements OnInit {

	private userGroups: Array<any>;
	private id: string;
	private accountId: any;

	constructor(
		private sessionService: SessionService,
		private router: Router,	
		private middlemanService: MiddlemanService
	) {}

	ngOnInit() {
		this.accountId = this.middlemanService.getData() ? this.middlemanService.getData().accountId : null;

		this.userGroups = this.sessionService.getUserGroups();
		
        if(!this.userGroups || this.userGroups.indexOf('credit-application-owner') === -1 || !this.accountId) {
            this.router.navigate(['/not-found'])
		}
	}
}



// WEBPACK FOOTER //
// ./src/app/agora/components/account-data/accounts/details/create-credit-application/create-credit-application.component.ts